module.exports = __webpack_public_path__ + "static/media/aeropods.14584f67.png";